<template>
  <div
    class="h-16 rounded-xl bg-white max-w-60 sm:max-w-[24rem] shadow-sm px-4 w-full flex flex-col items-center justify-center min-w-56 transition-all duration-150"
  >
    <div class="flex items-center justify-between w-full">
      <span class="text-sm text-gray-500">Week progress</span>
      <div>
        <span class="text-sm text-gray-500">{{ percentageDoneTasks }}%</span>
        <span v-if="percentageDoneTasks == 100" class="ml-2 inline-block shake-animation">🎉</span>
      </div>
    </div>
    <Progress :model-value="Number(percentageDoneTasks) || 0" class="h-2 [&>*]:bg-cosmicPurple" />
  </div>
</template>

<script setup lang="ts">
import { Progress } from '@/components/ui/progress'
import { useCurriculumStore } from '@/stores/curriculum'
import type { ProgressItem } from '@/types/curriculum'
import { computed } from 'vue'

const curriculumStore = useCurriculumStore()

const percentageDoneTasks = computed(() => {
  const weekTasks = curriculumStore.activeWeek?.progress
  let donePoints = 0
  let totalPoints = 0
  
  if (!weekTasks?.length) {
    return 0
  }
  
  weekTasks.forEach((task: ProgressItem) => {
    if (task.path_step.is_required) {
      totalPoints += task.path_step.points
      if (task.status === "DONE") {
        donePoints += task.path_step.points
      }
    }
  })
  
  if (totalPoints === 0) {
    return 0
  }
  
  const percentage = (donePoints / totalPoints) * 100
  return Number(percentage.toFixed(1))
})
</script>

<style scoped>
.shake-animation {
  animation: shake 1s ease-in-out both infinite;
}

@keyframes shake {
  0% {
    transform: rotate(0deg);
  }
  80% {
    transform: rotate(0deg);
  }
  85% {
    transform: rotate(10deg);
  }
  95% {
    transform: rotate(-10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
